import { useIsMobile } from '../../hook/useIsMobile';
import { BottomSnsPc } from './BottomSnsImg/BottomSnsImg.pc';
import { BottomSnsMobile } from './BottomSnsImg/BottomSnsImg.mobile';

export const BottomSns = () => {
  const isMobile = useIsMobile();
  return isMobile ? <BottomSnsMobile /> : <BottomSnsPc />;
};
